import { Notification } from "./Notification";
import { gValidStyleChoices, uiWidgetDimensions, widgetTypes } from "./constants";

export function UIWidget(pType, pData) {
  Notification.call(this);

  this.mType = pType;
  this.mProps = {};
  this.mStyles = {
    'position': 'absolute',
    'left': '0px',
    'top': '0px',
    'width': ((uiWidgetDimensions.gridCellWidth * 2) + uiWidgetDimensions.cellGutter) + 'px',
    'height': uiWidgetDimensions.gridCellHeight + 'px'
  };

  if (!widgetTypes.find(function(pValidType) { return pValidType === pType; })) {
    console.error('Unable to find widget with type: ' + this.mType);
    return;
  }

  pData ? this.fromJson(pData) : this.populateDefaultData();
}

UIWidget.prototype = Object.create(Notification.prototype);

UIWidget.prototype.fromJson = function(pJson) {
  this.mType = pJson.type;
  this.mStyles = Object.assign({}, pJson.styles);
  this.mProps = Object.assign({}, pJson.props);

  // The custom widget must be deserialized back into a function explicitly.
  switch (this.mType) {
    case 'custom': {
      this.mProps.renderFunc = eval('(' + this.mProps.renderFunc + ')');
      break;
    }
  }
};

UIWidget.prototype.toJson = function() {
  // The custom widget must be serialized from a function to a string explicitly.
  const lProps = { ...this.mProps };
  switch (this.mType) {
    case 'custom': {
      lProps.renderFunc = lProps.renderFunc.toString();
      break;
    }
  }

  return {
    type: this.mType,
    styles: this.mStyles,
    props: lProps
  };
};

// Mapping pixel length to Cell length
// Note (Ajay) the for loop upper limit should be the dimension with the larger number of cells.
const lCellPixelToCellMap = {};
for (let i = 1; i <= uiWidgetDimensions.gridWidth; i++) {
  lCellPixelToCellMap[(uiWidgetDimensions.gridCellWidth * i) + (uiWidgetDimensions.cellGutter * (i - 1))] = i;
}
UIWidget.prototype.getWidgetCellSize = function() {
  const lCellRow = lCellPixelToCellMap[parseInt(this.mStyles.height)];
  const lCellCol = lCellPixelToCellMap[parseInt(this.mStyles.width)];
  return [lCellRow, lCellCol];
};

UIWidget.prototype.populateDefaultData = function() {
  switch (this.mType) {
    case 'label': {
      this.mProps = {
        label: 'Label',
        selectedStyle: 'normal'
      };
      this.mStyles = Object.assign(this.mStyles, gValidStyleChoices[this.mProps.selectedStyle].css);
      break;
    }
    case 'eventButton': {
      this.mProps = Object.assign({
        label: 'Button',
        eventTopic: '',
        eventMessage: '',
      }, (this.mProps ? this.mProps : {}) );
      this.mStyles.backgroundColor = this.mStyles.backgroundColor ? this.mStyles.backgroundColor : "#1AC876";
      break;
    }
    case 'variableDisplay': {
      this.mProps = { label: 'Variable Display', variable: null};
      break;
    }
    case 'digitalInputDisplay': {
      this.mProps = { label: 'Digital Input Display', input: null};
      break;
    }
    case 'console': {
      this.mStyles.width = ((uiWidgetDimensions.gridCellWidth * 6)  + (uiWidgetDimensions.cellGutter * 5)) + 'px';
      this.mStyles.height = ((uiWidgetDimensions.gridCellHeight * 3) +  (uiWidgetDimensions.cellGutter * 2)) + 'px';
      break;
    }
    case 'dropdown': {
      this.mProps = Object.assign({
        label: 'Variable Input',
        variable: null,
        options: []
      }, (this.mProps ? this.mProps : {}));
      break;
    }
    case 'numericInput': {
      this.mProps = Object.assign({
        label: 'Variable Input',
        variable: null,
        defaultValue: '',
        min: null,
        max: null,
        maxHeight: 1
      }, (this.mProps ? this.mProps : {}));
      break;
    }
    case 'custom': {
      this.mProps = Object.assign({
        renderFunc: function(pDiv, pTraceData) { console.log('Rendering into a custom div', pDiv, pTraceData); }.toString()
      }, (this.mProps ? this.mProps : {}));
      break;
    }
    default:
      console.error('Unknown element type: ' + this.mType);
      break;
  }
};

UIWidget.prototype.getType = function() {
  return this.mType;
};

UIWidget.prototype.getProps = function() {
  return this.mProps;
};

UIWidget.prototype.getStyles = function() {
  return this.mStyles;
};

UIWidget.prototype.setType = function(pType) {
  this.mType = pType;
  this.populateDefaultData();
  this.notify('onTypeChanged', pType);
};

// Put style changes in this section
UIWidget.prototype.addStyle = function(pName, pValue) {
  this.mStyles[pName] = pValue;
  this.notify('onStyleChanged', pName, pValue);
};

UIWidget.prototype.setPosition = function(pX, pY) {
  this.mStyles.left = pX + 'px';
  this.mStyles.top = pY + 'px';
  this.notify('onPositionChanged', pX, pY);
};

UIWidget.prototype.setDimension = function(pWidth, pHeight) {
  this.mStyles.width = pWidth + 'px';
  this.mStyles.height = pHeight + 'px';
  this.notify('onDimensionChanged', pWidth, pHeight);
};

UIWidget.prototype.setDimensionByCellSize = function(pColumns, pRows) {
  const lW = (pColumns * uiWidgetDimensions.gridCellWidth) + ((pColumns - 1) * uiWidgetDimensions.cellGutter);
  const lH = (pRows * uiWidgetDimensions.gridCellHeight) + ((pRows - 1) * uiWidgetDimensions.cellGutter);
  this.setDimension(lW, lH);
};

UIWidget.prototype.setTextSize = function(pSize) {
  this.mStyles.fontSize = pSize + 'px';
  this.notify('onTextSizeChanged', pSize);
};

// Put prop changes in this section
UIWidget.prototype.setLabel = function(pLabel) {
  this.mProps.label = pLabel;
  this.notify('onLabelChanged', pLabel);
};

UIWidget.prototype.setDefaultValue = function(pDefaultValue) {
  switch (this.mType) {
    case 'numericInput':
      if (isNaN(Number(pDefaultValue))) {
        console.error('Default value is invalid: ' + pDefaultValue);
        return;
      }
      break;
    case 'dropdown':
      if (!this.mProps.options.find(function(pOption) { return pOption.value === pDefaultValue; })) {
        console.error('Default value is invalid: ' + pDefaultValue);
        return;
      }
      break;
    default:
      console.error('Cannot set default value for widget: ' + this);
      return;
  }

  this.mProps.defaultValue = pDefaultValue;
  this.notify('onDefaultValueChanged', pDefaultValue);
};

UIWidget.prototype.setOptions = function(pOptions) {
  if (this.mType !== 'dropdown') {
    console.error('Input type must be dropdown to set options');
    return;
  }

  if (!Array.isArray(pOptions)) {
    console.error('Options must be an array', pOptions);
    return;
  }

  for (let lIdx = 0; lIdx < pOptions.length; lIdx++) {
    if (pOptions[lIdx].value === undefined || pOptions[lIdx].text === undefined) {
      console.error('Option at index ' + lIdx + 'is malformed', pOptions);
      return;
    }
  }

  this.mProps.options = pOptions;
  this.notify('onOptionsChanged', pOptions);
};

UIWidget.prototype.setInputLimits = function(pMin, pMax) {
  if (this.mProps !== 'numericInput') {
    console.error('Input type must be numberInput to set limits');
    return;
  }

  this.mProps.min = pMin;
  this.mProps.max = pMax;
  this.notify('onLimitsChanged', pMin, pMax);
};

UIWidget.prototype.setEventTopic = function(pEventTopic) {
  if (this.mProps.type !== 'eventButton') {
    console.error('Widget must be eventButton to set event topic.');
    return;
  }

  this.mProps.eventTopic = pEventTopic;
  this.notify('onButtonEventChanged', this.mProps.eventTopic, this.mProps.eventMessage);
};

UIWidget.prototype.setEventMessage = function(pEventMessage) {
  if (this.mProps.type !== 'eventButton') {
    console.error('Widget must be eventButton to set event message.');
    return;
  }

  this.mProps.eventMessage = pEventMessage;
  this.notify('onButtonEventChanged', this.mProps.eventTopic, this.mProps.eventMessage);
};

UIWidget.prototype.setSequenceName = function(pSequenceName) {
  if (this.mProps.type !== 'sequenceButton') {
    console.error('Widget must be sequenceButton to set sequence name.');
    return;
  }

  this.mProps.sequenceName = pSequenceName;
  this.notify('onButtonSequenceChanged', this.mProps.sequenceName);
};

UIWidget.prototype.setRenderFunc = function(pRenderFunc) {
  if (this.mProps.type !== 'custom') {
    console.error('Widget must be a custom to set the render function');
    return;
  }

  this.mProps.renderFunc = pRenderFunc;
  this.notify('onRenderFunctionChanged', this.mProps.renderFunc);
};
